import { render, staticRenderFns } from "./StoryEditorAddDesionTool.vue?vue&type=template&id=33b38b54&scoped=true&"
import script from "./StoryEditorAddDesionTool.vue?vue&type=script&lang=js&"
export * from "./StoryEditorAddDesionTool.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditorAddDesionTool.vue?vue&type=style&index=0&id=33b38b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b38b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
